import { Component, OnInit, Inject } from '@angular/core';

import { LoggerService } from '../services/logger.service';


export class FooterComponent implements OnInit {
  year: Number;
  constructor( private loggerService: LoggerService) {
    this.year = new Date().getFullYear();
  }

  ngOnInit() {
    this.loggerService.log('... initializing footer component from core module.');
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-layout-footer]',
  template: `
  <div class="pull-right">
      Welcome to the jungle!
  </div>
  <div>
      <strong>Copyright</strong> Demo full application &copy; {{year}}
  </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LoggerService, decorators: [{ type: Inject, args: ['LoggerService', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
